"use strict";

exports.__esModule = true;
exports.resolveStyleCSSValue = void 0;
var _applyThemeVariables = require("./apply-theme-variables");
var _formatters = require("./formatters");
var _rules = require("./rules");
const resolveStyleCSSValue = (value, {
  themeVariables
}) => {
  if (!value.defaultValue) {
    return undefined;
  }
  const applyTheme = value => (0, _applyThemeVariables.applyThemeVariables)(value, themeVariables);
  const rule = (0, _rules.getRuleForType)(value.type);
  if (rule) {
    switch (rule.type) {
      case 'color':
        return (0, _formatters.formatColor)(value.defaultValue, applyTheme);
      case 'border':
        return (0, _formatters.formatBorder)(value.defaultValue, applyTheme);
      case 'font':
        return (0, _formatters.formatFont)(value.defaultValue, applyTheme);
      case 'stringOrNumber':
        return (0, _formatters.formatNumeric)({
          value: value.defaultValue,
          unit: rule.unit
        }, value => (0, _applyThemeVariables.applyThemeVariables)(value, themeVariables));
      case 'string':
      case 'boolean':
      default:
        return (0, _formatters.formatGeneric)(value.defaultValue, applyTheme);
    }
  }
  return (0, _formatters.formatGeneric)(value.defaultValue, applyTheme);
};
exports.resolveStyleCSSValue = resolveStyleCSSValue;
//# sourceMappingURL=resolve-style-css-value.js.map